// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__ebHBP","subheader":"ReorderModal_subheader__RkiAS","listWrap":"ReorderModal_listWrap__1n-j0"};